import script from "./AccordionBodyMap.vue?vue&type=script&setup=true&lang=js"
export * from "./AccordionBodyMap.vue?vue&type=script&setup=true&lang=js"

import "./AccordionBodyMap.vue?vue&type=style&index=0&id=de9b3a80&lang=css"

const __exports__ = script;

export default __exports__